import number from "./number";
import date from "./date";
import currency from "./currency";
import auth from "./auth";
import tasks from "./tasks";
import * as helper from "./helper";
import * as app from "./app";

export default {
  number,
  helper,
  date,
  auth,
  currency,
  tasks,
  app
};
